import { render, staticRenderFns } from "./home-bottom.vue?vue&type=template&id=65ce9866&scoped=true"
import script from "./home-bottom.vue?vue&type=script&lang=js"
export * from "./home-bottom.vue?vue&type=script&lang=js"
import style0 from "./home-bottom.vue?vue&type=style&index=0&id=65ce9866&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ce9866",
  null
  
)

export default component.exports